<template>
  <div class="device-map">
    <el-row class="warp">
      <el-col :span="24" class="warp-breadcrum">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }"><b>首页</b></el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/device/device' }">设备状态</el-breadcrumb-item>
          <el-breadcrumb-item>地图展示</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <baidu-map
        class="bm-view"
        ak="68gqtbhlTp0oWG4oywdD5YG0bG5hPq4C"
        :center="mapConfig.center"
        :zoom="mapConfig.zoom"
        :scroll-wheel-zoom="mapConfig.scrollWheelZoom"
        :auto-resize="mapConfig.autoResize"
        @ready="handler">
        <template v-for="(item, index) in markerDatas">
          <baidu-marker 
            :position="{lng: item.deviceLongitude, lat: item.deviceLatitude}" 
            :key="index" 
            :icon="{url: require('../../assets/images/loc_red.png'),size: {width: 30, height: 30}}"
            @click="handleMarkerClick($event, item)">
            <baidu-label 
              v-if="item.deviceCount > 1" 
              :content="item.deviceCount + '台'" 
              :labelStyle="{color: 'black', fontSize : '12px'}" 
              :offset="{width: 25, height: -10}"/>
          </baidu-marker>
        </template>
        <baidu-info-window 
          :position="infoWindow.position"
          :title="infoWindow.title"
          :show="infoWindow.show">
          <div class="content">
            <template v-for="(item,index) in infoWindow.deviceDatas">
              <div class="device-item" :key="index">
                <div class="info">
                  <label>
                    <i v-if="item.deviceWarState === 1" class="fa fa-circle" aria-hidden="true" style="color:green">
                      <label style="color: black;">在线</label>
                    </i>
                    <i v-else-if="item.deviceWarState === 2" class="fa fa-circle" aria-hidden="true" style="color:red">
                      <label style="color: black;">离线</label>
                    </i>
                    <i v-else-if="item.deviceWarState === 0" class="fa fa-circle" aria-hidden="true" style="color:yellow">
                      <label style="color: black;">未知</label>
                    </i>
                  </label>
                  <label style="font-weight:bold;">{{ item.deviceCode }}</label>
                  <label style="font-weight:bold;">{{ formatterCategory(item.deviceCategoryId) }}</label>
                </div>
                <div class="address">{{item.provinceName + item.cityName + item.districtName + item.addressDetail + item.devicePosition}}</div>
              </div>
            </template>
          </div>
        </baidu-info-window>
      </baidu-map>
    </el-row>
  </div>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BaiduMarker from "vue-baidu-map/components/overlays/Marker.vue";
import BaiduLabel from "vue-baidu-map/components/overlays/Label.vue";
import BaiduInfoWindow from "vue-baidu-map/components/overlays/InfoWindow.vue";
import DEVICE_API from '../../api/api_device';

export default {
  name: "DeviceMap",
  data() {
    return {
      mapConfig: {
        center: { lng: 0, lat: 0 },  //定位
        zoom: 3,  //缩放等级
        autoResize: true, //允许自适应容器尺寸
        scrollWheelZoom: true,  //允许鼠标滚轮缩放
      },
      infoWindow: {
        title: '',
        show: false,
        position: {},
        devicePos: {},
        deviceDatas: []
      },
      markerDatas: [],
      deviceCategory: []
    };
  },
  computed: {
    formatterCategory() {
      return (deviceCategoryId) => {
        var category = '';
        this.deviceCategory.forEach(function(item, index){
          if (deviceCategoryId === item.value) {
            category = item.label;
          }
        });
        return category;
      }
    }
  },
  methods: {
    handler({ BMap, map }) {
      //console.log(BMap, map);
      // 设置定位-北京
      this.mapConfig.center.lng = 116.404;
      this.mapConfig.center.lat = 39.915;
      this.mapConfig.zoom = 5;
    },
    deviceMapData() {
      let that = this;
      DEVICE_API.deviceMap(this.$route.query)
      .then(
        function(result) {
          if (result && result.code == 200) {
            that.markerDatas= result.data;
          }
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    handleMarkerClick (event, data) {
      let that = this;
      this.infoWindow.position = Object.assign({}, event.point);
      this.infoWindow.devicePos = Object.assign({}, {
        longitude: data.deviceLongitude,
        latitude: data.deviceLatitude
      });
      this.infoWindow.deviceDatas = [];
      this.deviceMapMarkerData(function(result){
         that.infoWindow.show = true;
      });
    },
    deviceMapMarkerData(callback) {
      let that = this;
      let params = Object.assign({}, this.infoWindow.devicePos);
      //如果有省份参数，则参入
      let province = this.$route.query.province;
      if(province){
        params.province= province;
      }
      DEVICE_API.deviceMapMarker(params)
      .then(
        function(result) {
          if (result && result.code == 200) {
            that.infoWindow.deviceDatas = result.data;
            if (typeof callback === "function") {
              callback(result.data);
            }
          }
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    },
    deviceCategoryCombox() {
      let that = this;
      DEVICE_API.deviceCategoryCombox()
      .then(
        function(result) {
          if (result && result.code == 200) {
            that.deviceCategory = result.data;
          }
        },
        function(error) {
          that.$message.error({
            showClose: true,
            message: error.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error){
        that.$message.error({
          showClose: true,
          message: '请求出现异常',
          duration: 2000
        });
      });
    }
  },
  mounted() {
    this.deviceMapData();
    this.deviceCategoryCombox();
  },
  components: {
    BaiduMap,
    BaiduMarker,
    BaiduLabel,
    BaiduInfoWindow
  }
};
</script>
<style lang="scss" scoped>
.device-map {

  .bm-view {
    width: 100%;
    height: 800px;
  }

  .content {
    .device-item {
      box-sizing: content-box;
      padding: 0 0 20px 0;

      .device-status {
        display: block;
        width: 16px;
        height: 16px;
        border-radius: 8px
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// deviceMap.vue?988fc848